interface Language {
  code: string
  name: string
  flag: string
}

interface TranslationLanguageMultiSelectorProps {
  label: string
  selectedLanguages: string[]
  onToggleLanguage: (languageCode: string) => void
  onSelectAll: () => void
  onClearAll: () => void
  languages: Language[]
  className?: string
  showSelectAllControls?: boolean
  selectAllText?: string
  clearAllText?: string
  existingTranslations?: string[]
}

export function TranslationLanguageMultiSelector({ 
  label, 
  selectedLanguages, 
  onToggleLanguage, 
  onSelectAll, 
  onClearAll,
  languages, 
  className = "",
  showSelectAllControls = true,
  selectAllText = "Select All",
  clearAllText = "Clear All",
  existingTranslations = []
}: TranslationLanguageMultiSelectorProps) {
  return (
    <div className={className}>
      <div className="flex justify-between items-center mb-3">
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
        {showSelectAllControls && (
          <div className="space-x-2">
            <button
              type="button"
              onClick={onSelectAll}
              className="text-xs text-blue-600 hover:text-blue-800"
            >
              {selectAllText}
            </button>
            <button
              type="button"
              onClick={onClearAll}
              className="text-xs text-gray-600 hover:text-gray-800"
            >
              {clearAllText}
            </button>
          </div>
        )}
      </div>
      
      <div className="space-y-2">
        {languages.map((language) => {
          const hasExistingTranslation = existingTranslations.includes(language.code)
          return (
            <label key={language.code} className="flex items-center p-2 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">
              <input
                type="checkbox"
                checked={selectedLanguages.includes(language.code)}
                onChange={() => onToggleLanguage(language.code)}
                className="mr-3"
              />
              <span className="mr-2">{language.flag}</span>
              <span className="text-sm font-medium flex-1">{language.name}</span>
              {hasExistingTranslation && (
                <span className="ml-auto text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                  ✓
                </span>
              )}
            </label>
          )
        })}
      </div>
    </div>
  )
}